// extracted by mini-css-extract-plugin
export default {"contest":"AlbumContest_contest__Q6dK2","singleAlbum":"AlbumContest_singleAlbum__eqz8V","albumImage":"AlbumContest_albumImage__Pkc90","text":"AlbumContest_text__JWXwH"};